<div *ngIf="setting && setting.length > 0" class="d-flex justify-content-end px-2 py-1 bg-light border-bottom position-relative">
  <button class="btn btn-sm btn-outline-secondary" type="button" (click)="toggleColumnSelector()">Columns</button>
  <div *ngIf="showColumnSelector" class="position-absolute bg-white border rounded shadow p-2 end-0" style="top: 100%; min-width: 160px; z-index: 1050;">
    <div *ngFor="let h of setting; let i = index" class="form-check" [style.display]="h.label ? '' : 'none'">
      <input class="form-check-input" type="checkbox" [id]="'col-vis-' + i"
             [checked]="!hiddenColumns.includes(h.label)"
             [disabled]="!hiddenColumns.includes(h.label) && visibleSetting.length <= 1"
             (change)="toggleColumn(h.label)" />
      <label class="form-check-label small" [for]="'col-vis-' + i">{{h.label}}</label>
    </div>
  </div>
</div>
<div *ngIf="error" class="alert alert-danger m-2" role="alert">
  {{error}} <button type="button" class="btn btn-sm btn-outline-danger" (click)="setPage(current_page)">Retry</button>
</div>
<div class="table-container">
    <table class="table table-striped mb-0">
        <thead class="bg-dark text-light">
            <tr *ngIf="setting" style="position: sticky;top: 0">
                <th *ngFor="let h of visibleSetting" class="table-header">
                    <ng-container *ngIf="!h.hide">
                        {{h.label}}
                    </ng-container>
                </th>
            </tr>
        </thead>
        <tbody *ngIf="content && content.length > 0">
            <tr *ngFor="let c of content; let i = index;">
                <td *ngFor="let h of visibleSetting" [class.bg-warning]="h.primary_bg" [class.border-start]="h.border_left"
                    [class.border-end]="h.border_right">
                    <container-element [ngSwitch]="h.type">
                        <ng-container *ngSwitchCase="'checkbox'">
                            <input type="checkbox" [(ngModel)]="c.checked" [value]="true" />
                        </ng-container>
                        <ng-container *ngSwitchCase="'index'">
                            {{i + 1 + ((current_page - 1) * (no_per_page ? no_per_page : 20)) }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'status'">
                        <span *ngIf="h.key === 'status' && c.is_suspended == 1" class="badge bg-danger">Suspended</span>
                        <span *ngIf="h.key !== 'status' || c.is_suspended != 1" class="badge" [ngClass]="c[h.key] ? 'bg-success' : 'bg-secondary'">{{c[h.key] ? 'Active' : 'Disabled'}}</span>
                    </ng-container>
                        <ng-container *ngSwitchCase="'yesno'">
                            <span *ngIf="c[h.key]">Yes</span>
                            <span *ngIf="!c[h.key]">No</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            {{displayValue(c, h)}}
                        </ng-container>
                        <ng-container *ngSwitchCase="'copystring'">
                            <a (click)="copyFunction(c[h.key])">{{c[h.key]}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'date'">
                            <span class="text-nowrap">{{c[h.key] | date: 'dd-MM-y'}}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'price'">
                            <div class="d-flex flex-row justify-content-between"><span>{{configuration.currency ==
                                    "none" ? "": configuration.currency}}</span><span>{{(c[h.key] ? parseFloat(c[h.key])
                                    : 0) | number: (h.digits || '1.2-2') }}</span></div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'link'">
                            <a *ngIf="is_mario || !h.hide_super_admin || (h.hide_super_admin && c['is_super_admin'] != '1') || (h.hide_create_by_me && c['create_by_me'] == '1')"
                                [routerLink]="h.blockWhenSuspended && c.is_suspended == 1 ? null : [h.link, c[h.key]]" [class.disabled]="h.blockWhenSuspended && c.is_suspended == 1" [attr.aria-disabled]="h.blockWhenSuspended && c.is_suspended == 1 ? true : null">{{h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'custom_link'">
                            <a *ngIf="!h.visible_if || h.visible_if(c)" (click)="h.func(c, ngbModal)">{{h['link_text'] || h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'link-status'">
                            <a [routerLink]="h.blockWhenSuspended && c.is_suspended == 1 ? null : [h.link, c[h.key]]" [class.disabled]="h.blockWhenSuspended && c.is_suspended == 1" [attr.aria-disabled]="h.blockWhenSuspended && c.is_suspended == 1 ? true : null" *ngIf="c['status'] == 1 && c.is_suspended != 1">{{h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'query-link-status'">
                            <a [routerLink]="[h.link]" [queryParams]="linkQueryParams(h, c)"
                                *ngIf="c['status'] == 1 && c.is_suspended != 1">{{h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'delete'">
                            <a *ngIf="is_mario ||!h.hide_super_admin || (h.hide_super_admin && c['is_super_admin'] != '1') || (h.hide_create_by_me && c['create_by_me'] == '1')"
                                (click)="delete(c[h.title], h.table, c[h.key])">{{h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'claim'">
                            <a (click)="claim(c)">
                                <span *ngIf="!c[h.key]">Claim</span>
                                <svg *ngIf="c[h.key]" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    fill="rgb(40, 167, 69)" class="bi bi-check-square-fill" viewBox="0 0 16 16">
                                    <path
                                        d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                                </svg>
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'timestamp'">
                            <span class="text-nowrap">{{c[h.key] | date: 'short'}}</span>
                        </ng-container>
                        <ng-container *ngSwitchCase="'copy'">
                            <a (click)="copy(c)">{{h['label']}}</a>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{c[h.key]}}
                        </ng-container>
                    </container-element>
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="show_sum && content && content.length > 0">
            <tr>
                <td *ngFor="let h of visibleSetting" [class.border-start]="h.border_left" [class.border-end]="h.border_right">
                    <div *ngIf="h.sum">
                        <ng-container *ngIf="h.type === 'string' && h.key === 'string'">
                            <div><span>{{h.key}}</span></div>
                        </ng-container>
                        <ng-container class="w-100" *ngIf="h.type === 'price'">
                            <div class="d-flex flex-row justify-content-between">
                                <span>{{configuration.currency == "none" ? "": configuration.currency}}</span>
                                <span>{{ (summary && summary[h.key] !== undefined ? summary[h.key] : sum(h.key)) |
                                    number : (h.digits || '1.2-2') }}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="h.type === 'string'">
                            <div><span>{{ (summary && summary[h.key] !== undefined ? summary[h.key] : sum(h.key)) |
                                    number : '1.2-2' }}</span></div>
                        </ng-container>
                    </div>
                    <div *ngIf="h.deduct">
                        <div><span>{{sum(h.deduct[0]) - sum(h.deduct[1]) | number : '1.2-2'}}</span></div>
                    </div>
                </td>
            </tr>
        </tfoot>
        <tbody *ngIf="setting && content.length == 0 && !is_loading && !error">
            <td [attr.colspan]="visibleSetting.length" class="p-3">
                No Data Available
            </td>
        </tbody>
        <tbody *ngIf="setting.length > 0 && is_loading">
            <td class="d-flex flex-row align-items-center ps-1" [attr.colspan]="visibleSetting.length">
                <div class="loader"></div> <span>Loading</span>
            </td>
        </tbody>
        <tbody *ngIf="is_load && (!setting || setting.length == 0)">
            <td>
                Table is not setup properly.
            </td>
        </tbody>
    </table>
</div>
<div *ngIf="!disabled_pagenat && pagenat && pagenat.total > 0"
    class="d-flex flex-row justify-content-between align-items-center p-3 bg-light border-top">
    <div class="d-flex flex-row align-items-center gap-3">
        <div class="text-muted">Total: {{pagenat.total | number}} records</div>
        <span class="text-muted small" style="opacity:.55" *ngIf="configuration && (configuration.currency || configuration.timezone)">{{configuration.timezone ? 'UTC' + configuration.timezone : ''}}{{configuration.timezone && configuration.currency && configuration.currency !== 'none' ? ' · ' : ''}}{{configuration.currency && configuration.currency !== 'none' ? configuration.currency : ''}}</span>
        <div class="d-flex flex-row align-items-center gap-2">
            <span class="text-muted small">Show:</span>
            <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="no_per_page"
                (change)="setPageSize(no_per_page)">
                <option *ngFor="let size of [20, 50, 100, 250, 500]" [value]="size">{{size}}</option>
            </select>
        </div>
    </div>
    <nav>
        <ul class="pagination mb-0">
            <li class="page-item" [class.disabled]="!pagenat.previous">
                <a class="page-link" href="javascript:void(0)"
                    (click)="pagenat.previous && setPage(pagenat.previous)">Previous</a>
            </li>
            <li class="page-item" *ngFor="let p of pagenat.pagenat" [class.active]="p == pagenat.current">
                <a class="page-link" href="javascript:void(0)" (click)="setPage(p)">{{p}}</a>
            </li>
            <li class="page-item" [class.disabled]="!pagenat.next">
                <a class="page-link" href="javascript:void(0)" (click)="pagenat.next && setPage(pagenat.next)">Next</a>
            </li>
        </ul>
    </nav>
</div>
